import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

interface Product {
  productNumber: string;
  productName: string;
  businessUnit: string;
  customer: string;
}

@Component({
  selector: 'app-addprojectmodalpopup',
  templateUrl: './addprojectmodalpopup.component.html',
  styleUrls: ['./addprojectmodalpopup.component.scss']
})
export class AddprojectmodalpopupComponent implements OnInit {
  buttonColorName: any;
  loggedInUserCompanyID: any;
  selectedYearForDWM: any = null;
  loggedInCompanyFiscalyear: any;
  subModuleButtonColor: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  isCurrentYearSelected: boolean = false;
  pmsYears: any = [];
  productNumberCtrl = new FormControl('', Validators.required);
  productNameCtrl = new FormControl('', Validators.required);
  plantCtrl = new FormControl(null, Validators.required);
  businessUnitCtrl = new FormControl('', Validators.required);
  customerCtrl = new FormControl('', Validators.required);
  productId: any = null;
  isEdit = false;
  plantList: any[] = [];

  displayedColumns: string[] = ['productNumber', 'productName', 'businessUnit', 'customer'];

  dataSource = new MatTableDataSource<Product>([]);
  // Form fields
  newRow: Product = {
    productNumber: '',
    productName: '',
    businessUnit: '',
    customer: ''
  };
  sort: any;
  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private snackBar: MatSnackBar,
    private loadingService: LoaderService,
    public dialogRef: MatDialogRef<AddprojectmodalpopupComponent>,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }
    this.isEdit = this.data?.isEdit || false;
    if (this.isEdit && this.data.product) {
      const p = this.data.product;

      this.productId = p.id;
      this.productNumberCtrl.setValue(p.productNo);
      this.productNameCtrl.setValue(p.productName);
      this.plantCtrl.setValue(p.plantLocation);
      this.customerCtrl.setValue(p.productCustomer);
      this.businessUnitCtrl.setValue(p.businessUnit);
    }
    this.getpmsyearlist();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      // console.log("fiscal year..", this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      this.getPlants();
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
  }

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;
  }

  getPlants() {
    this.httpService.callGetService(`${this.config.getPlantList}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      this.plantList = data?.data || [];
    });
  }

  addProductData() {
    if (this.productNumberCtrl.invalid || this.productNameCtrl.invalid || this.plantCtrl.invalid || this.businessUnitCtrl.invalid || this.customerCtrl.invalid) {
      this.productNumberCtrl.markAsTouched();
      this.productNameCtrl.markAsTouched();
      this.plantCtrl.markAsTouched();
      this.businessUnitCtrl.markAsTouched();
      this.customerCtrl.markAsTouched();
      return;
    }

    // console.log(this.productNumberCtrl.value, this.productNameCtrl.value, this.productNameCtrl.value, this.businessUnitCtrl.value,)
    const payload: any = {
      year: this.selectedYearForDWM,
      productId: this.productId ? this.productId : null,
      companyId: this.loggedInUserCompanyID,
      productNo: this.productNumberCtrl.value,
      productName: this.productNameCtrl.value,
      businessUnit: this.businessUnitCtrl.value,
      productCustomer: this.customerCtrl.value,
      plantLocation: this.plantCtrl.value
    };

    this.httpService.callPostService(this.config.saveOrUpdateProduct, payload).subscribe({
      next: (data: any) => {
        // console.log("Added product:", data);

        // Success toast
        this.toastr.success('Product added successfully!', 'Success');
        this.dialogRef.close(true);
      },

      error: (err: any) => {
        console.error('Error saving product:', err);

        let errorMessage = 'Something went wrong. Please try again.';

        if (err?.error?.message) {
          errorMessage = err.error.message;
        }

        this.toastr.error(errorMessage, 'Error');
      }
    });
  }
}
